// Re-Tech Black Friday / Cyber Monday 2026: shows BF prices on collection cards and product pages.
// The discount itself is a Shopify automatic discount (applied in the cart); this only displays it.
// Data comes from snippets/rt-bf.liquid ([data-rt-bf]): tier amounts per handle + one daily drop per day
// (Sofia date) that replaces the tier amount for that card on that day.
// Preview helpers: ?bf=on / ?bf=off force the sale on/off; ?bfday=2026-11-27 simulates a sale day (both kept for the session).
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const parse = el => { try { return JSON.parse(el?.textContent || 'null'); } catch { return null; } };
  const bf = parse($('[data-rt-bf]'));
  if (!bf) return;
  const ss = {
    get(k) { try { return sessionStorage.getItem(k); } catch { return null; } },
    set(k, v) { try { v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch {} }
  };
  const q = new URLSearchParams(location.search);
  if (q.get('bf') === 'on') ss.set('retech.bf.force', '1');
  if (q.get('bf') === 'off') { ss.set('retech.bf.force', null); ss.set('retech.bf.day', null); }
  if (/^\d{4}-\d{2}-\d{2}$/.test(q.get('bfday') || '')) ss.set('retech.bf.day', q.get('bfday'));
  const force = ss.get('retech.bf.force') === '1';
  const on = force || (Date.now() >= Date.parse(bf.start) && Date.now() <= Date.parse(bf.end));
  if (!on) return;
  const today = ss.get('retech.bf.day') || new Date().toLocaleDateString('en-CA', {timeZone: 'Europe/Sofia'});
  const drop = (bf.drops || []).find(d => d.d === today) || null;
  const en = bf.locale === 'en';
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const eur = n => (Math.round(n * 100) / 100).toLocaleString(en ? 'en-IE' : 'bg-BG', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' €';
  const amt = h => (drop && drop.h === h) ? drop.amt : (Number(bf.amt?.[h]) || 0);
  const isDrop = h => !!(drop && drop.h === h);
  const T = en
    ? {card: 'Black Friday', dropCard: 'Deal of the day', line: 'Black Friday: <b>{now}</b> instead of <s>{was}</s> (−{off}). Applied automatically in the cart, no code needed.', dropLine: 'Deal of the day, today only: <b>{now}</b> instead of <s>{was}</s> (−{off}). Applied automatically in the cart.'}
    : {card: 'Black Friday', dropCard: 'Оферта на деня', line: 'Black Friday: <b>{now}</b> вместо <s>{was}</s> (−{off}). Отстъпката се прилага автоматично в количката, без код.', dropLine: 'Оферта на деня, само днес: <b>{now}</b> вместо <s>{was}</s> (−{off}). Прилага се автоматично в количката.'};
  const fill = (s, o) => s.replace(/\{(\w+)\}/g, (_, k) => o[k] ?? '');

  // collection / grid cards
  function cards(scope = document) {
    $$('[data-rts-card][data-handle]', scope).forEach(card => {
      if (card.dataset.rtBf || card.dataset.state === 'sold') return;
      const h = card.dataset.handle, off = amt(h); if (!off) return;
      const was = Number(card.dataset.price) / 100; if (!(was > off)) return;
      const box = $('.rts-card-price', card); if (!box) return;
      $('.rs2-hwprice', card)?.remove();
      const el = document.createElement('p'); el.className = 'rt-bf-price';
      el.innerHTML = '<span class="rt-bf-tag' + (isDrop(h) ? ' is-drop' : '') + '">−' + esc(eur(off)) + '</span><b>' + esc(eur(was - off)) + '</b> <span>' + esc(isDrop(h) ? T.dropCard : T.card) + '</span>';
      box.after(el); card.dataset.rtBf = '1';
    });
  }
  cards();
  document.addEventListener('rts:render', e => cards(e.target), true);

  // product page
  const prod = $('[data-rts-product]');
  const h = prod?.dataset.handle;
  const off = prod ? amt(h) : 0;
  if (prod && off) {
    let variants = [];
    try { variants = JSON.parse($('[data-rts-variants]', prod)?.textContent || '[]') || []; } catch {}
    const priceEl = $('[data-rts-price]', prod);
    const line = document.createElement('p'); line.className = 'rt-bf-line'; line.hidden = true;
    (priceEl || $('form[data-rts-add]', prod))?.insertAdjacentElement(priceEl ? 'afterend' : 'beforebegin', line);
    const cur = () => {
      const id = $('form[data-rts-add] [name=id]', prod)?.value;
      return variants.find(x => String(x.id) === String(id)) || [...variants].sort((a, b) => a.cents - b.cents)[0] || null;
    };
    const render = () => {
      const v = cur();
      if (!v || v.state === 'sold' || v.state === 'enquiry' || !(v.cents / 100 > off)) { line.hidden = true; return; }
      const was = v.cents / 100;
      line.innerHTML = '<span class="rt-bf-tag' + (isDrop(h) ? ' is-drop' : '') + '">−' + esc(eur(off)) + '</span><span>' + fill(isDrop(h) ? T.dropLine : T.line, {now: esc(eur(was - off)), was: esc(eur(was)), off: esc(eur(off))}) + '</span>';
      line.hidden = false;
    };
    render();
    if (priceEl) new MutationObserver(render).observe(priceEl, {childList: true, characterData: true, subtree: true});
    $('form[data-rts-add]', prod)?.addEventListener('change', () => setTimeout(render, 0));
  }
})();
